import { pluralise } from '@lib/utils';

type VehicleBranchProps = {
  name: string;
  url: string;
  distance_to_customer?: number;
  icon?: string;
  nofollow?: boolean;
  prefix?: string;
  vehicleMovable?: boolean;
};

const VehicleBranch = ({
  name,
  url,
  distance_to_customer,
  icon,
  nofollow,
  prefix,
  vehicleMovable,
}: VehicleBranchProps) => {
  const renderDistanceText = (distance: number): string => {
    const roundedDistance = Math.floor(distance);
    return roundedDistance < 1
      ? ' (Less than 1 mile)'
      : ` (${roundedDistance} ${pluralise(roundedDistance, 'mile')})`;
  };

  const getIcon = () => {
    if (vehicleMovable) return undefined;
    if (icon) return icon;
    return 'location-pin';
  };

  const displayIcon = getIcon();

  return (
    <a
      className={`vehicle-branch${
        displayIcon ? ` vehicle-branch--${displayIcon} ch-pv--1` : ''
      }`}
      href={url.toLowerCase()}
      rel={nofollow ? 'nofollow' : undefined}
    >
      {prefix && prefix.includes('Collect') ? (
        <span className="ch-flex--none ch-fs--1 ch-lh--heading ch-color--grey-6">
          Collect in{' '}
          <span className="vehicle-branch__collect-days ch-fw--500">
            {vehicleMovable ? 7 : 2} days
          </span>{' '}
          from{' '}
        </span>
      ) : (
        prefix && (
          <span className="ch-flex--none ch-fs--1 ch-lh--heading ch-color--grey-6">
            {prefix}{' '}
          </span>
        )
      )}
      <span className="ch-fs--1 ch-lh--heading ch-color--grey-6 ch-text--ellipsis">
        {name}
      </span>
      {typeof distance_to_customer === 'number' && (
        <span className="ch-flex--none">
          {renderDistanceText(distance_to_customer)}
        </span>
      )}
    </a>
  );
};

export default VehicleBranch;
